import { noop } from 'underscore';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { SDKEventTypes, sendSDKEvent } from '@bingads-webui-campaign-react/sdk-utils';

import { AdPreviewBanner } from '@bingads-webui-campaign-react/pmax-landing-preview-banner';

const initSDK = () => {
  if (window.parent && window.parent !== window) {
    sendSDKEvent({
      type: SDKEventTypes.SDKAdBannerReady,
    });
  }
};

const onCreateAdClick = () => {
  sendSDKEvent({
    type: SDKEventTypes.AdBannerClicked,
  });
};

export function PMaxLiteAdBannerCore(props) {
  const { logger } = props;

  useEffect(() => {
    initSDK();
  }, []);

  return <AdPreviewBanner logger={logger} onCreateAdClick={onCreateAdClick} />;
}

PMaxLiteAdBannerCore.propTypes = {
  logger: PropTypes.shape({
    trace: PropTypes.func.isRequired,
  }),
};

PMaxLiteAdBannerCore.defaultProps = {
  logger: {
    trace: noop,
  },
};

